import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"
import t from "theme"

//if no width given, apply default padding between the text and the angledown. If width given, have it be a flexbox.

const TabMenu = ({ choices, selected, ...props }) => (
    <div
        css={css`
            display: flex;

            height: 100%;
        `}
        {...props}>
        {choices.map((choice, index) => (
            <Link to={choice.pathname}>
                <div
                    css={css`
                        color: ${selected.toLowerCase() === choice.id.toLowerCase()
                            ? t.color.primary
                            : t.color.bodytext};
                        font-weight: ${selected.toLowerCase() === choice.id.toLowerCase()
                            ? t.font.weight.semibold
                            : t.font.weight.regular};
                        height: 100%;
                        display: flex;
                        padding: 0 ${t.space[4]};
                        align-items: center;
                        position: relative;
                        :hover {
                            color: ${t.color.primary};
                        }
                    `}>
                    <div>{choice.label}</div>
                    {selected.toLowerCase() === choice.id.toLowerCase() && (
                        <div
                            css={css`
                                position: absolute;
                                left: calc(${t.space[4]} - 2px);
                                bottom: 0;
                                width: calc(100% - ${t.space[4]} * 2 + 4px);
                                height: 3px;
                                background-color: ${t.color.primary};
                            `}
                        />
                    )}
                </div>
            </Link>
        ))}
    </div>
)

export default TabMenu
